import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_API_URL || 'http://localhost:3002'}`;

export interface AgentSummary {
  agent_id: string;
  agent_name: string;
  status: 'draft' | 'testing' | 'active' | 'inactive';
  created_at: string;
  updated_at: string;
}

export interface AgentsResponse {
  agents: AgentSummary[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export async function listAgents(page = 1, limit = 20): Promise<AgentsResponse> {
  const { data } = await axios.get(
    `${API_BASE}/api/v1/agents`,
    {
      params: { page, limit, sort_by: 'created_at', sort_order: 'desc' },
      withCredentials: true,
    }
  );
  return data;
}
